// @ts-nocheck
import * as React from 'react';
import { useSelector } from 'react-redux';
import { NOODLE_DEFAULT_IMAGE_MOBILE } from 'commons/constants';
import { getUtmContent } from 'utils/slug/index';
import ProgramCardWrapper from './ProgramCard.style';
import type { ProgramCardProps, RequestInfoOverlayProps } from './ProgramCard.types';

const RequestInfoOverlay = ({
  isVisible,
  link,
  onRequestInfo,
  onCancel,
}: RequestInfoOverlayProps): React.ReactElement<any> | null =>
  isVisible ? (
    <div className='request-info-overlay'>
      <span
        className='request-info-overlay__request-info-btn'
        onClick={onRequestInfo}
        onKeyPress={onRequestInfo}
        role='button'
        tabIndex={0}
      >
        Request info
      </span>
      <a
        className='request-info-overlay__program-page-btn'
        href={link}
        target='_blank'
        rel='noopener noreferrer'
      >
        Visit program page
      </a>
      <span
        className='request-info-overlay__cancel-btn'
        onClick={onCancel}
        onKeyPress={onCancel}
        role='button'
        tabIndex={0}
      >
        Cancel
      </span>
    </div>
  ) : null;

const ProgramCard = ({
  program,
  onSelectProgram,
  onToggleModal,
}: ProgramCardProps): React.ReactElement<any> | null => {
  const pathname = useSelector((state) => state.router.location.pathname || '');
  const [isSubmenuVisible, setIsSubmenuVisible] = React.useState(false);
  const [isDescriptionOpen, setIsDescriptionOpen] = React.useState(false);
  const PREVIEW_TEXT_WORD_COUNT = 15;

  if (program) {
    const {
      coverImage = NOODLE_DEFAULT_IMAGE_MOBILE,
      description,
      institutionName,
      logoImage,
      programName,
      schoolName,
      url,
    } = program;
    const utmUrl = `${url}&utm_source=noodle_linkout_prospect&utm_content=${getUtmContent(
      pathname,
    )}&utm_term=embed`;

    const handleSubmenuVisibility = () => setIsSubmenuVisible(!isSubmenuVisible);

    const handleSelect = () => onSelectProgram(program);

    const handleRequestInfo = () => {
      onToggleModal();
      handleSubmenuVisibility();
      onSelectProgram(program);
    };

    const handleReadMoreClick = () => setIsDescriptionOpen(!isDescriptionOpen);

    const getPreviewText = () => description.split(' ').slice(0, PREVIEW_TEXT_WORD_COUNT).join(' ');

    const renderDescription = () =>
      !isDescriptionOpen ? (
        <p className='program-card__description'>
          {getPreviewText()} (
          <span
            onKeyPress={handleReadMoreClick}
            onClick={handleReadMoreClick}
            role='button'
            tabIndex={programName}
            className='program-card__read-more'
          >
            more
          </span>
          )
        </p>
      ) : (
        <p className='program-card__description'>{description}</p>
      );

    const submenuProps = {
      isVisible: isSubmenuVisible,
      link: utmUrl,
      onCancel: handleSubmenuVisibility,
      onRequestInfo: handleRequestInfo,
    };
    return (
      <ProgramCardWrapper className='program-card'>
        <div className='program-card__image-container'>
          <RequestInfoOverlay {...submenuProps} />
          <div
            onClick={handleSubmenuVisibility}
            onKeyPress={handleSubmenuVisibility}
            role='menu'
            tabIndex={0}
          >
            <img
              alt={schoolName}
              className='program-card__image'
              src={coverImage}
              loading='lazy'
              width='100%'
              height='100%'
            />
          </div>
          <img
            src={logoImage}
            alt={schoolName}
            className='program-card__logo'
            loading='lazy'
            width='100%'
            height='100%'
          />
        </div>
        <h2 className='program-card__title'>{institutionName}</h2>
        <h3 className='program-card__subtitle'>{schoolName}</h3>
        <h4 className='program-card__subtitle2'>{programName}</h4>
        {renderDescription()}
        <span
          className='program-card__request-info'
          onClick={handleSelect}
          onKeyPress={handleSelect}
          role='button'
          tabIndex={programName}
        >
          +Request more info
        </span>
      </ProgramCardWrapper>
    );
  }

  return null;
};

export default ProgramCard;
